import { writeFile } from 'xlsx';

export const saveCSVReport = (obj, filename) => {
  const url = URL.createObjectURL(obj);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const saveXLSXReport = (data, filename) => {
  writeFile(data, `${filename}.xlsx`);
};
